const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const styles = require("./styles/TutorialModalButton.css");

module.exports = createReactClass({
	displayName: "TutorialModalButton",

	propTypes: {
		className: PT.string,
		onClick: PT.func.isRequired,
		text: PT.string.isRequired,
	},

	onClick: function(evt) {
		this.props.onClick();
	},

	render: function() {
		return (
			<div
				className={this.props.className + " " + styles.mainText}
				onClick={this.onClick}
			>
				<svg
					version="1.1"
					x="0px"
					y="0px"
					viewBox="0 0 26 30"
					width="26"
					height="30"
					preserveAspectRatio="none"
					className={styles.image}
				>
					<path
						className={styles.imageColor}
						d="M19,6.6c1.3-1.1,2.3-2.9,2.4-3c0.2-0.4,0-0.8-0.5-0.8C18.5,3,13.8,2.4,10.8,2.1c-0.4,0-0.9,0.1-0.5,0.9
                        c0.6,1.7,1.3,6.3,1.2,10c0,0.4,0.2,0.4,0.7,0.1c0.2-0.1,2-0.9,3.4-2.8C17,11.7,19,13,19,16.1c0,3.6-1.7,7.5-6.8,7.6
                        c-9.5,0.3-8.8-10.1-6-13.5c-4.7,2.5-5.7,8.5-3.4,12.4c1.8,3.1,5,5.3,10.1,5.3c4.5,0,7.9-2.2,9.9-5.9C26.4,15.4,23.3,9.5,19,6.6z"
					/>
				</svg>
				<span className={styles.text}>{this.props.text}</span>
			</div>
		);
	},
});
